module.exports = {"TXTCLI_Watch_Games":{"id":"TXTCLI_Watch_Games","defaultMessage":"Nézz játékokat","track":"Watch Games"}}